<template>

  <div class="padded">

    <h2><i class="fa fa-sitemap" />&nbsp;Structure Report<small v-if="isTowerCo()"><check-box v-model="sup" @change="getData" no-form>View Suppliers</check-box></small></h2>
    <br />

    <el-tabs type="border-card" stretch>
      <el-tab-pane v-for="(l, i) in list" :key="l.status" :label="l.status" lazy>

          <el-row>

            <el-col :sm="24" :md="12">

              <good-table
                :cols="cols"
                :rows="l.data"
                striped
                theme="polar-bear"
              />
<!--
              <el-table
                   :data="l.data"
                   border
                   stripe
                   show-summary
                   sum-text="Totals"
                   :summary-method="summaryFormatter"
                   style="width: 100%">

                   <el-table-column
                      prop="structName"
                      :width="isDesktop ? 250 : 500"
                      label="Structure">
                   </el-table-column>

                   <el-table-column
                      v-if="sup && isTowerCo()"
                      prop="name"
                      :width="isDesktop ? 250 : 500"
                      label="Supplier">
                   </el-table-column>

                   <el-table-column
                        prop="height"
                        label="Height"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

                   <el-table-column
                        prop="quantity"
                        label="Qty"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

              </el-table>
-->
            </el-col>

            <el-col :sm="24" :md="12">
              <pie-chart :data="chart[i].data"
              :donut="true"
              thousands=","
              legend=""
              :colors="colors" />
            </el-col>

          </el-row>
        </el-tab-pane>

      </el-tabs>

  </div>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'
/* import ElTableMixins from '@/mixins/ElTableMixins' */
import NumberMixins from '@/mixins/NumberMixins'

import {chartColors} from '@/components/Data'

export default {
//  mixins: [PostMixins, ElTableMixins, NumberMixins],
  mixins: [PostMixins, NumberMixins],

  props: {

    supplier: {
      type: Boolean,
      default: false
    }

  },


  methods: {


    getData () {

      this.list = []
      this.chart = []

      if (this.sup) {
        this.fetchData('/report/structures/supplier/raw', this.successReport, 'Structure Supplier Report')
      } else {
        this.fetchData('/report/structures/raw', this.successReport, 'Structure Report')
      }

    },



    successReport (data) {

      if (this.sup && !this.isTowerSupplierCo()) {
        this.cols[1].hidden = false
      } else {
        this.cols[1].hidden = true
      }

      let status = null
      let k = -1

      for (var i = 0; i < data.length; i++) {

        if (data.length > 0 && data[i].status !== status) {
          k += 1
          status = data[i].status
          this.chart.push({'status': status, 'data': []})
          this.list.push({'status': status, 'data': []})
        }

        this.chart[k]['data'].push([data[i].structName, Number(data[i].quantity)])
        this.list[k]['data'].push({'structName': data[i].structName, 'name': (this.sup ? data[i].name : null), 'height': Number(data[i].height), 'quantity': Number(data[i].quantity)})
      }

    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['quantity'], null, null, ['height'])
    }

  },



  data () {
    return {
      sup: this.supplier,
      cols: [
            {
             label: 'Structure',
             field: 'structName'
           },
           {
            label: 'Supplier',
            field: 'name',
            hidden: (this.supplier && this.isTowerCo())
          },
          {
           label: 'Height',
           field: 'height',
           type: 'number'
         },
         {
          label: 'Qty',
          field: 'quantity',
          type: 'number'
        },
          ],
      list: [],
      chart: [],
      colors: chartColors,
    }

  },

  created () {
    this.getData()
  }

}

</script>



// WEBPACK FOOTER //
// StructureReport.vue?cf4b0994